import {
  BodyLG,
  BodyLGB,
  BodyMDB,
  BodyXL,
  Heading2XL,
  Heading5XL,
} from "../../../typography";

import { Link } from "react-router-dom";
import { StandardButton } from "@verse_core/shared_components/buttons/StandardButton";

const SECTION_LABEL = "Signature Collection for Home Health Agencies";
const SECTION_TITLE = "Stop Losing Revenue to Unsigned Orders - Without Adding Work for Your Team";
const SECTION_DESCRIPTION =
  "Verse automates provider signature collection so your staff stops chasing paperwork and your agency captures every dollar it’s earned.";
const BUTTON_TEXT = "Get started";

export const Hero = () => (
  <div className="tw-relative tw-flex tw-items-center tw-gap-y-[32px]">
    <div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-x-[16px] tw-gap-y-[42px] min440:tw-flex-row min440:tw-px-[24px]">
      <div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-y-[1.5em] tw-text-center min440:tw-w-full min440:tw-max-w-[calc(65%)] min440:tw-items-start min440:tw-text-left">
        <Heading2XL className="tw-my-0 tw-hidden tw-w-full tw-text-white min1040:tw-flex">
          {SECTION_LABEL}
        </Heading2XL>
        <BodyXL className="tw-my-0 tw-w-full tw-text-white min1040:tw-hidden">
          {SECTION_LABEL}
        </BodyXL>
        <Heading5XL className="tw-my-0 tw-hidden tw-w-full tw-text-white min1040:tw-flex">
          {SECTION_TITLE}
        </Heading5XL>
        <Heading2XL className="tw-my-0 tw-w-full tw-text-white min1040:tw-hidden">
          {SECTION_TITLE}
        </Heading2XL>

        <BodyXL className="tw-my-0 tw-hidden tw-w-full tw-text-white min1040:tw-flex">
          {SECTION_DESCRIPTION}
        </BodyXL>
        <BodyLG className="tw-my-0 tw-w-full tw-text-white min1040:tw-hidden">
          {SECTION_DESCRIPTION}
        </BodyLG>

        <Link to="/contact" className="tw-no-underline">
          <StandardButton
            onClick={() => {}}
            style={"primary-blue"}
            className="tw-w-[15em] tw-rounded-full tw-px-[2em] tw-py-[1em] tw-text-[16px]"
          >
            <BodyLGB className="tw-my-0 tw-hidden tw-text-white min440:tw-block">
              {BUTTON_TEXT}
            </BodyLGB>
            <BodyMDB className="tw-my-0 tw-text-white min440:tw-hidden">
              {BUTTON_TEXT}
            </BodyMDB>
          </StandardButton>
        </Link>
      </div>
    </div>
  </div>
);
